import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-439e5270")

_pushScopeId("data-v-439e5270")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pa-4 d-flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "iconfont iconreport-icon-jiexi title-icon" }, null, -1)
const _hoisted_4 = {
  class: "text-center",
  style: {"font-size":"26px"}
}
const _hoisted_5 = { class: "pt-4" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "pb-4 desc" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "pb-4 desc" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "desc" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_cell_group = _resolveComponent("van-cell-group")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")
  const _component_van_dialog = _resolveComponent("van-dialog")

  return ($setup.deductOfItems.filter((it) => $props.analysis[it.key]).length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_my_card, { class: "mt-4" }, {
          header: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.$t("deduct.analysisOofSleepDeductionPoints")), 1 /* TEXT */)
            ])
          ]),
          default: _withId(() => [
            _createVNode(_component_my_card_body, null, {
              default: _withId(() => [
                _createVNode(_component_van_cell_group, { border: false }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.deductOfItems, (item, key) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: key }, [
                        ($props.analysis[item.key])
                          ? (_openBlock(), _createBlock(_component_van_cell, {
                              key: 0,
                              class: "py-3 cell-item",
                              title: item.title,
                              value: `-${$props.analysis[item.key]}`,
                              onClick: $event => ($setup.show(item.key))
                            }, null, 8, ["title", "value", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_dialog, {
          show: $setup.dialogShow,
          "onUpdate:show": _cache[1] || (_cache[1] = $event => ($setup.dialogShow = $event)),
          "show-confirm-button": false,
          "close-on-click-overlay": ""
        }, {
          default: _withId(() => [
            _createVNode(_component_my_card, { class: "pa-4" }, {
              header: _withId(() => [
                _createVNode("div", _hoisted_4, _toDisplayString($setup.deductOfItem.title), 1)
              ]),
              default: _withId(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("deduct.factor")), 1),
                  _createVNode("div", _hoisted_7, _toDisplayString($setup.deductOfItem.factor), 1),
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("deduct.analysis")), 1),
                  _createVNode("div", _hoisted_9, _toDisplayString($setup.deductOfItem.analysis), 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("deduct.recommendation")), 1),
                  _createVNode("div", _hoisted_11, _toDisplayString($setup.deductOfItem.proposal), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
})